import { jsx as _jsx } from "react/jsx-runtime";
import clsx from 'clsx';
import { memo } from 'react';
import { ComplianceStatus } from '../../../types/proposal';
const STATUS_OPTIONS = [
    {
        value: ComplianceStatus.ADDRESSED,
        label: 'Addressed',
        color: 'text-green-700 bg-green-50 border-green-200'
    },
    {
        value: ComplianceStatus.PARTIAL,
        label: 'Partial',
        color: 'text-yellow-700 bg-yellow-50 border-yellow-200'
    },
    {
        value: ComplianceStatus.NOT_STARTED,
        label: 'Not Started',
        color: 'text-gray-700 bg-gray-50 border-gray-200'
    },
    {
        value: ComplianceStatus.IN_PROGRESS,
        label: 'In Progress',
        color: 'text-blue-700 bg-blue-50 border-blue-200'
    },
    {
        value: ComplianceStatus.NON_COMPLIANT,
        label: 'Non-Compliant',
        color: 'text-red-700 bg-red-50 border-red-200'
    },
    {
        value: ComplianceStatus.NOT_APPLICABLE,
        label: 'N/A',
        color: 'text-gray-500 bg-gray-50 border-gray-200'
    }
];
export const StatusDropdown = /*#__PURE__*/ memo(function StatusDropdown({ value, onChange, disabled = false, testid }) {
    const handleChange = (e)=>{
        onChange(e.target.value);
    };
    const currentOption = STATUS_OPTIONS.find((opt)=>opt.value === value);
    return /*#__PURE__*/ _jsx("select", {
        value: value,
        onChange: handleChange,
        disabled: disabled,
        "data-testid": testid,
        className: clsx('px-3 py-1 text-sm font-medium rounded border transition-colors', 'focus:outline-none focus:ring-2 focus:ring-blue-500', currentOption?.color, disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer hover:opacity-80'),
        children: STATUS_OPTIONS.map((option)=>/*#__PURE__*/ _jsx("option", {
                value: option.value,
                children: option.label
            }, option.value))
    });
});
